import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap, map, tap } from 'rxjs';

import * as CommonIdGetDesiredUniversitiesActions from '../../actions/common-id/common-id-get-desired-universities.actions';
import { FirebaseCallableFunctionError } from '../../errors/firebase-callable-function-error';
import { CommonIdGetDesiredUniversitiesService } from 'src/app/services/common-id/common-id-get-desired-universities.service';

@Injectable()
export class CommonIdGetDesiredUniversitiesEffects {
  private LOG_SOURCE = this.constructor.name;

  /* 最新志望校の大学情報取得 */
  commonIdGetDesiredUniversities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversities),
      switchMap(action =>
        this.commonIdGetDesiredUniversitiesService.commonIdGetDesiredUniversities(action.request).pipe(
          map(response => CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesSuccess({ response })),
          catchError(e =>
            of(
              CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesFailure({ error: FirebaseCallableFunctionError.from(e) })
            )
          )
        )
      )
    )
  );

  /* トークン情報の更新 */
  saveTokenInfoToLocalStorage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesSuccess),
        tap(({ response }) => {
          localStorage.setItem('tokenInfo', JSON.stringify(response.tokenInfo));
        })
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private commonIdGetDesiredUniversitiesService: CommonIdGetDesiredUniversitiesService) {}
}
